import { Button } from 'components/common';
import { intercom } from 'libs';

interface Brokerage {
  id: number;
  name: string;
  logo_path: string;
}

interface JoinRequest {
  id: number;
  brokerage: Brokerage;
  status: string;
}
interface ResolvedJoinRequestProps {
  joinRequest: JoinRequest;
}

const ResolvedJoinRequest = ({ joinRequest }: ResolvedJoinRequestProps) => {
  const isCancelled = joinRequest.status === 'cancelled';
  return (
    <div className="card">
      <div className="card-header fw-bold h4">{isCancelled ? 'Request cancelled' : 'Request declined'}</div>
      <div className="card-body pt-3">
        <div className="d-flex flex-column w-100">
          <div className="align-items-center d-flex fw-bold gap-2">
            <div
              className="background-center-contain flex-shrink-0 rounded-circle shadow-2"
              data-testid="team-info-logo"
              style={{
                backgroundImage: `url(${joinRequest.brokerage?.logo_path ?? '/images/spotlight-logo-200x200.png'})`,
                height: 50,
                width: 50,
              }}
            />
            {joinRequest.brokerage?.name}
          </div>
        </div>
        <p className="pt-4">
          {isCancelled
            ? 'You’ve cancelled your request to join this team. '
            : 'Your request to join this team was declined. '}
          If you’d like to get set up with a team, please reach out to&nbsp;
          <Button onClick={() => intercom.showMessage('I want to join a team.')} text="bold" variant="link-inline">
            customer support.
          </Button>
        </p>
      </div>
    </div>
  );
};

export default ResolvedJoinRequest;
